import React, { FunctionComponent } from 'react';

import styles from './TimelineProgressBar.module.scss';

export interface RankingTimelineProgressDto {
  total: number;
  current: number;
}

interface TimelineProgressBar {
  label: string;
  progress?: RankingTimelineProgressDto;
  dateUpdated: string;
}

const TimelineProgressBar: FunctionComponent<TimelineProgressBar> = ({
  label,
  progress = { current: 0, total: 0 },
  dateUpdated,
}) => {
  const percents = progress.total > 0 ? (100 * progress.current) / progress.total : 0;

  return (
    <div>
      <p className={[styles.progressLabel, 'o-layout__unstyled-element'].join(' ')}>{label}</p>
      <div className={styles.progressWrapper}>
        <div className={styles.progressBar}>
          <div className={styles.progressBarFilled} style={{ width: `${percents}%` }} />
          <div className={styles.progressBox} />
          <div className={styles.progressBox} />
          <div className={styles.progressBox} />
          <div className={styles.progressBox} />
          <div className={styles.progressBox} />
          <div className={styles.progressBox} />
          <div className={styles.progressBox} />
          <div className={styles.progressBox} />
        </div>
        <div className={styles.progressText}>
          {percents.toFixed(1)}% ({progress.current} out of {progress.total})
        </div>
        {dateUpdated && (
          <span className="mba-font--16" style={{ color: '#afafaf', marginLeft: '10px' }}>
            updated on {dateUpdated}
          </span>
        )}
      </div>
    </div>
  );
};

export default TimelineProgressBar;
